// src/reducers/auth_reducers.js
import {
  EMAIL_CHANGED,
  PASSWORD_CHANGED,
  LOGGED_IN_SUCCESS,
  LOGGED_IN_FAIL,
  SET_TOKEN,
  CLEAR_TOKEN,
  CLEAR_LOGIN_ERROR,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CLEAR_CHANGE_PASSWORD_ERROR,
  FETCH_USERS_LOADING,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAIL,
  UPDATE_USER_FLAG_LOADING,
  UPDATE_USER_FLAG_SUCCESS,
  UPDATE_USER_FLAG_FAIL,

  CREATE_USER_LOADING,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  DELETE_USER_LOADING,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,

  NOTIFY_CREDENTIALS_LOADING,
  NOTIFY_CREDENTIALS_SUCCESS,
  NOTIFY_CREDENTIALS_FAIL,

  FETCH_ROLES_LOADING,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAIL,

  UPDATE_USER_ROLE_LOADING,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_FAIL,

  //Managing Roles
  FETCH_PERMISSIONS_LOADING,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAIL,
  FETCH_ROLE_PERMISSIONS_LOADING,
  FETCH_ROLE_PERMISSIONS_SUCCESS,
  FETCH_ROLE_PERMISSIONS_FAIL,
  REPLACE_ROLE_PERMISSIONS_LOADING,
  REPLACE_ROLE_PERMISSIONS_SUCCESS,
  REPLACE_ROLE_PERMISSIONS_FAIL,

  CREATE_ROLE_LOADING,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAIL,

  DELETE_ROLE_LOADING,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,

} from "../actions/types";

const INITIAL_STATE = {
  welcome: [],
  email: "",
  password: "",
  currentpassword: "",
  newpassword: "",
  newpassword2: "",
  changepassword: [],
  logininfo: null, // Will be { error: "..." } on failure
  role: null,
  permissions: [],  // access permissions
  isAuthenticated: false,
  token: null,
  changepassword_info: null,
  users: [],
  usersLoading: false,
  usersError: null,
  updatingFlag: null, 
  updateFlagError: null,
  notifyLoading: false,
  notifyMessage: null,
  notifyError: null,

  roles: [],
  rolesLoading: false,
  rolesError: null,

  updatingRoleEmail: null,
  updateRoleError: null,

  // Managing Roles Related
    // Permissions (master list)
  permissionsMaster: [],
  permissionsMasterLoading: false,
  permissionsMasterError: null,

  // Permissions for the currently selected role
  currentRoleId: null,
  rolePermissions: [],
  rolePermissionsLoading: false,
  rolePermissionsError: null,

  // Replace role permissions
  replacingRolePermissions: null,   // holds roleId while updating
  replaceRolePermissionsError: null,

  //Create Roles
  createRoleLoading: false,
  createRoleError: null,

  //Delete a Role
  deletingRoleId: null,
  deleteRoleError: null,

};

function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {

  // --- Delete a Role
  case DELETE_ROLE_LOADING:
  return {
    ...state,
    deletingRoleId: action.payload.roleId,
    deleteRoleError: null
  };

case DELETE_ROLE_SUCCESS: {
  const rid = action.payload.roleId;

  return {
    ...state,
    deletingRoleId: null,
    // Remove the role from the roles list
    roles: (state.roles || []).filter(r => Number(r.id) !== Number(rid)),
    // Keep UI consistent with backend: users who had this role now default to 1
    users: (state.users || []).map(u =>
      Number(u.Role_Id) === Number(rid)
        ? { ...u, Role_Id: 1 }
        : u
    )
  };
}

case DELETE_ROLE_FAIL:
  return {
    ...state,
    deletingRoleId: null,
    deleteRoleError: action.payload?.message || 'Failed to delete role'
  };

  // --- Create Role
  case CREATE_ROLE_LOADING:
    return {
      ...state,
      createRoleLoading: true,
      createRoleError: null
    };

  case CREATE_ROLE_SUCCESS: {
    const newRole = action.payload;
    const roles = Array.isArray(state.roles) ? [...state.roles] : [];
    const idx = roles.findIndex(r => Number(r.id) === Number(newRole.id));

    if (idx >= 0) {
      roles[idx] = newRole;           // replace if it already exists
    } else {
      roles.push(newRole);            // otherwise add
    }

    // keep roles sorted by id (optional, matches your fetch order)
    roles.sort((a, b) => Number(a.id) - Number(b.id));

    return {
      ...state,
      createRoleLoading: false,
      roles
    };
  }

  case CREATE_ROLE_FAIL:
    return {
      ...state,
      createRoleLoading: false,
      createRoleError: action.payload
    };

    // --- Permissions (master)
    case FETCH_PERMISSIONS_LOADING:
      return { 
        ...state, 
        permissionsMasterLoading: true, 
        permissionsMasterError: null 
      };
    case FETCH_PERMISSIONS_SUCCESS:
      return { 
        ...state, 
        permissionsMasterLoading: false, 
        permissionsMaster: action.payload 
      };
    case FETCH_PERMISSIONS_FAIL:
      return { 
        ...state, 
        permissionsMasterLoading: false, 
        permissionsMasterError: action.payload 
      };

    // --- Permissions by role
    case FETCH_ROLE_PERMISSIONS_LOADING:
      return { 
        ...state, 
        rolePermissionsLoading: true, 
        rolePermissionsError: null,
        currentRoleId: action.payload?.roleId ?? state.currentRoleId
      };
    case FETCH_ROLE_PERMISSIONS_SUCCESS:
      return { 
        ...state, 
        rolePermissionsLoading: false, 
        rolePermissions: action.payload.permissions || [],
        currentRoleId: action.payload.roleId
      };
    case FETCH_ROLE_PERMISSIONS_FAIL:
      return { 
        ...state, 
        rolePermissionsLoading: false, 
        rolePermissionsError: action.payload 
      };

    // --- Replace role permissions
    case REPLACE_ROLE_PERMISSIONS_LOADING:
      return { 
        ...state, 
        replacingRolePermissions: action.payload.roleId, 
        replaceRolePermissionsError: null 
      };
    case REPLACE_ROLE_PERMISSIONS_SUCCESS: {
      const { roleId, permissions } = action.payload;
      // If we are currently viewing the same role, reflect changes immediately
      const shouldUpdateVisible = Number(state.currentRoleId) === Number(roleId);
      return { 
        ...state, 
        replacingRolePermissions: null,
        rolePermissions: shouldUpdateVisible ? (permissions || []) : state.rolePermissions
      };
    }
    case REPLACE_ROLE_PERMISSIONS_FAIL:
      return { 
        ...state, 
        replacingRolePermissions: null, 
        replaceRolePermissionsError: action.payload 
      };


    // --- Roles list
    case FETCH_ROLES_LOADING:
      return { ...state, rolesLoading: true, rolesError: null };

    case FETCH_ROLES_SUCCESS:
      return { ...state, rolesLoading: false, roles: action.payload };

    case FETCH_ROLES_FAIL:
      return { ...state, rolesLoading: false, rolesError: action.payload };

    // --- Update user role
    case UPDATE_USER_ROLE_LOADING:
      return { ...state, updatingRoleEmail: action.payload.email, updateRoleError: null };

    case UPDATE_USER_ROLE_SUCCESS: {
      const { email, roleId } = action.payload;
      return {
        ...state,
        updatingRoleEmail: null,
        // update Role_Id in users table row (if loaded)
        users: Array.isArray(state.users)
          ? state.users.map(u =>
              (u.Email && u.Email.toLowerCase()) === (email || '').toLowerCase()
                ? { ...u, Role_Id: roleId }
                : u
            )
          : state.users
      };
    }

    case UPDATE_USER_ROLE_FAIL:
      return { ...state, updatingRoleEmail: null, updateRoleError: action.payload };

    //Update User Active Flag
        case UPDATE_USER_FLAG_LOADING:
      return {
        ...state,
        updatingFlag: action.payload,
        updateFlagError: null
      };
    case UPDATE_USER_FLAG_SUCCESS:
      return {
        ...state,
        updatingFlag: null,
        users: state.users.map(u =>
          u.User_Id === action.payload.userId
            ? { ...u, Active_Flag: action.payload.activeFlag }
            : u
        )
      };
    case UPDATE_USER_FLAG_FAIL:
      return {
        ...state,
        updatingFlag: null,
        updateFlagError: action.payload
      };

    //Fetch Dashboard Users
    case FETCH_USERS_LOADING:
      return { ...state, usersLoading: true, usersError: null };
    case FETCH_USERS_SUCCESS:
      return { ...state, usersLoading: false, users: action.payload };
    case FETCH_USERS_FAIL:
      return { ...state, usersLoading: false, usersError: action.payload };
    case EMAIL_CHANGED:
      return { ...state, email: action.payload };
    case PASSWORD_CHANGED:
      return { ...state, password: action.payload };
    case LOGGED_IN_SUCCESS:
          return {
            ...state,
            logininfo: action.payload.user,
            role: action.payload.role || null,
            permissions: action.payload.permissions || [],
            isAuthenticated: true,
          };
    case LOGGED_IN_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        permissions: [],
        role: null,
        logininfo: action.payload?.error ? { error: action.payload.error } : null
      };
    case SET_TOKEN:
      return { ...state, token: action.payload };
    case CLEAR_TOKEN:
      return { ...state, token: null };
    case CLEAR_LOGIN_ERROR:
      return { ...state, logininfo: null };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changepassword_info: action.payload,
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        changepassword_info: action.payload,
      };
    case CLEAR_CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changepassword_info: null,
      };

    // User Management
    case CREATE_USER_LOADING:
    case DELETE_USER_LOADING:
      return { ...state, loading: true, error: null };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: [action.payload, ...state.users]
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.filter(
          (u) => u.Email?.toLowerCase() !== action.payload.email.toLowerCase()
        )
      };

    case CREATE_USER_FAIL:
    case DELETE_USER_FAIL:
      return { ...state, loading: false, error: action.payload };

   case NOTIFY_CREDENTIALS_LOADING:
      return { 
        ...state, 
        notifyLoading: true, 
        notifyMessage: null, 
        notifyError: null 
      };

    case NOTIFY_CREDENTIALS_SUCCESS:
      return { 
        ...state, 
        notifyLoading: false, 
        notifyMessage: action.payload 
      };

    case NOTIFY_CREDENTIALS_FAIL:
      return { 
        ...state, 
        notifyLoading: false, 
        notifyError: action.payload 
      };      

    default:
      return state;
  }
}

export default authReducer;
